// Navigation Configuration
// Defines the structure and hierarchy of the navigation system

import { NavigationConfig } from './types';

export const navigationConfig: NavigationConfig = {
  sections: [
    {
      id: 'overview',
      label: 'Overview',
      items: [
        {
          id: 'dashboard',
          label: 'Dashboard',
          icon: 'LayoutDashboard',
          path: '/',
          isActive: true
        }
      ]
    },
    {
      id: 'server-management',
      label: 'Server Management',
      isCollapsible: true,
      isExpanded: true,
      items: [
        {
          id: 'all-servers',
          label: 'All Servers',
          icon: 'Server',
          path: '/servers',
          badge: 'live'
        },
        {
          id: 'running-servers',
          label: 'Running Servers',
          icon: 'Play',
          path: '/servers/running'
        },
        {
          id: 'scheduled-operations',
          label: 'Scheduled Operations',
          icon: 'Clock',
          path: '/servers/scheduled'
        },
        {
          id: 'server-templates',
          label: 'Server Templates',
          icon: 'Copy',
          path: '/servers/templates'
        }
      ]
    },
    {
      id: 'analytics-monitoring',
      label: 'Analytics & Monitoring',
      isCollapsible: true,
      isExpanded: false,
      items: [
        {
          id: 'performance-metrics',
          label: 'Performance Metrics',
          icon: 'Activity',
          path: '/analytics/performance'
        },
        {
          id: 'cost-analytics',
          label: 'Cost Analytics',
          icon: 'DollarSign',
          path: '/analytics/costs'
        },
        {
          id: 'usage-reports',
          label: 'Usage Reports',
          icon: 'BarChart3',
          path: '/analytics/usage'
        },
        {
          id: 'alerts-notifications',
          label: 'Alerts & Notifications',
          icon: 'Bell',
          path: '/analytics/alerts'
        }
      ]
    },
    {
      id: 'settings-account',
      label: 'Settings & Account',
      isCollapsible: true,
      isExpanded: false,
      items: [
        {
          id: 'user-profile',
          label: 'User Profile',
          icon: 'User',
          path: '/settings/profile'
        },
        {
          id: 'billing-usage',
          label: 'Billing & Usage',
          icon: 'CreditCard',
          path: '/settings/billing'
        },
        {
          id: 'notification-preferences',
          label: 'Notification Preferences',
          icon: 'Settings',
          path: '/settings/notifications'
        },
        {
          id: 'api-keys',
          label: 'API Keys & Integrations',
          icon: 'Key',
          path: '/settings/api'
        }
      ]
    }
  ],
  defaultActiveItem: 'dashboard',
  defaultExpandedSections: ['overview', 'server-management'],
  collapsible: true
};